<template>
  <div>
    <transition name="fade">
      <div
        v-if="showReviewOrganization"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed right-0 overflow-y-auto bg-white shadow-2xl sm:w-1/2 w-full overflow-x-hidden h-screen"
        >
          <div
            v-if="loading"
            class="absolute inset-0 z-50 bg-black bg-opacity-50"
          >
            <loader class="absolute center-h-v" />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div
            class="flex justify-between items-center border-b-1.5 p-3 sticky top-0 bg-white z-10"
          >
            <p>Review Organization</p>
            <img
              class="h-5 object-contain bg-primary rounded-md cursor-pointer hover:shadow-lg"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="p-3">
            <!-- {{ organizationData }} -->
            <div class="px-5 mt-5">
              <div class="relative">
                <img
                  class="h-10 sm:h-14 object-contain"
                  :alt="organizationData.Name"
                  :src="
                    organizationData.Logo
                      ? organizationData.Logo
                      : 'https://www.clker.com/cliparts/b/l/0/w/q/3/modified-generic-company-logo.svg'
                  "
                />
              </div>
              <div
                v-if="currentUserType !== 'admin'"
                class="absolute top-20 left-60 bg-primary rounded-md p-1"
              >
                <img
                  class="h-3 object-contain cursor-pointer hover:shadow-lg"
                  src="@/assets/icons/pencil.png"
                  @click="editLogo()"
                  title="Edit logo"
                />
              </div>
            </div>
            <div class="p-5 text-sm font-semibold mt-5 text-black">
              Basic Information
              <div class="mt-1 border-b-0.5 border-gray-300 h-full"></div>
            </div>

            <div class="flex gap-x-5 gap-y-8 px-5">
              <div>
                <p class="text-xs">Organization Name</p>
                <p>{{ organizationData.Name }}</p>
              </div>
              <div>
                <p class="text-xs">Contact Email</p>
                <p>{{ organizationData.Email }}</p>
              </div>
              <div>
                <p class="text-xs">Contact Phone No.</p>
                <p>{{ organizationData.Phonenumber }}</p>
              </div>
            </div>

            <div class="p-5 text-sm font-semibold mt-5 text-black">
              Documents
              <div class="mt-1 border-b-0.5 border-gray-300 h-full"></div>
            </div>

            <div class="flex w-full gap-5 items-center px-5">
              <div class="flex flex-col gap-2 place-items-center">
                <div class="relative">
                  <img
                    class="h-5 cursor-pointer object-contain"
                    @click="
                      (e) =>
                        openPDFViewer(e, organizationData.CompanyRegistration)
                    "
                    src="@/assets/icons/document.png"
                  />
                </div>
                <div
                  v-if="currentUserType !== 'admin'"
                  class="absolute left-28 bg-primary rounded-md p-1"
                >
                  <img
                    class="h-3 object-contain cursor-pointer hover:shadow-lg"
                    src="@/assets/icons/pencil.png"
                    @click="editBusinessPermit()"
                    title="Edit Business Permit"
                  />
                </div>
                <p
                  @click="
                    (e) => openPDFViewer(e, organizationData.BusinessPermit)
                  "
                  class="text-buttonColor text-sm cursor-pointer"
                >
                  Business Permit
                </p>
              </div>

              <div class="flex flex-col gap-2 place-items-center">
                <div class="relative">
                  <img
                    class="h-5 cursor-pointer object-contain"
                    @click="
                      (e) =>
                        openPDFViewer(e, organizationData.CompanyRegistration)
                    "
                    src="@/assets/icons/document.png"
                  />
                </div>
                <div
                  v-if="currentUserType !== 'admin'"
                  class="absolute left-56 ml-2 bg-primary rounded-md p-1"
                >
                  <img
                    class="h-3 object-contain cursor-pointer hover:shadow-lg"
                    src="@/assets/icons/pencil.png"
                    @click="editCR12Certificate()"
                    title="Edit CR12 Certificate"
                  />
                </div>
                <p
                  @click="
                    (e) => openPDFViewer(e, organizationData.CR12Certificate)
                  "
                  class="text-buttonColor text-sm cursor-pointer"
                >
                  CRI2 Certificate
                </p>
              </div>
              <div class="flex flex-col gap-2 place-items-center">
                <img
                  class="h-5 cursor-pointer object-contain"
                  @click="
                    (e) =>
                      openPDFViewer(e, organizationData.CompanyRegistration)
                  "
                  src="@/assets/icons/document.png"
                />
                <div
                  v-if="currentUserType !== 'admin'"
                  class="absolute left-96 ml-2 bg-primary rounded-md p-1"
                >
                  <img
                    class="h-3 object-contain cursor-pointer hover:shadow-lg"
                    src="@/assets/icons/pencil.png"
                    @click="editCompanyRegistration()"
                    title="Edit Company Registration"
                  />
                </div>
                <p
                  class="text-buttonColor text-sm cursor-pointer"
                  @click="
                    (e) =>
                      openPDFViewer(e, organizationData.CompanyRegistration)
                  "
                >
                  Company Registration
                </p>
              </div>
            </div>

            <div class="p-5 text-sm font-semibold mt-5 text-black">
              License Information
              <div class="mt-1 border-b-0.5 border-gray-300 h-full"></div>
            </div>
            <div class="px-5 w-1/2 text-sm mb-3">
              <div class="flex items-center justify-between gap-5 mb-3">
                <p>Status</p>
                <p class="font-semibold">
                  <span class="text-green-500">{{
                    organizationData.SubscriptionStatus
                  }}</span>
                </p>
              </div>

              <div class="flex items-center justify-between gap-5 mb-3">
                <p>License Start Date</p>
                <p class="font-semibold">
                  {{
                    formatDate(organizationData.LicenseStartDate).format(
                      "DD/MM/YYYY HH:MM"
                    )
                  }}
                </p>
              </div>
              <div class="flex items-center justify-between gap-5 mb-3">
                <p>License Expiry</p>
                <p class="font-semibold">
                  {{
                    formatDate(organizationData.LicenseEndDate).format(
                      "DD/MM/YYYY HH:MM"
                    )
                  }}
                </p>
              </div>
              <div class="flex items-center justify-between gap-5 mb-3">
                <p>Total Manager</p>
                <p class="font-semibold">
                  {{ organizationData.TotalManagers }}
                </p>
              </div>
              <div class="flex items-center justify-between gap-5 mb-3">
                <p>Total Normal Employees</p>
                <p class="font-semibold">
                  {{ organizationData.TotalNormalEmployees }}
                </p>
              </div>
            </div>
            <div
              v-if="organizationData.Approved"
              class="p-5 text-sm font-semibold mt-5 text-black mb-3"
            >
              Payment Terms
              <div class="mt-1 border-b-0.5 border-gray-300 h-full"></div>
            </div>
            <div class="px-5 w-1/2 text-sm mb-3">
              <div class="flex justify-between mb-4">
                <p>Current Payment Terms</p>
                <p class="font-semibold">
                  {{
                    organizationData.PaymentTerms.Name
                      ? organizationData.PaymentTerms.Name
                      : "None"
                  }}
                </p>
              </div>
              <!-- <p>Update Payment Terms</p> -->
              <div
                class="flex flex-col items-center justify-between gap-5 mb-3"
              >
                <el-select
                  v-model="organizationData.PaymentTypeId"
                  placeholder="Select a payment term"
                  class="bg-gray-200 rounded-full w-full border-none"
                  @change="updatePaymentTerms"
                >
                  <el-option
                    v-for="paymentTerm in licenceBillingPeriods"
                    :key="paymentTerm.Id"
                    :label="paymentTerm.Name"
                    :value="paymentTerm.Id"
                  >
                    {{ paymentTerm.Name }}
                  </el-option>
                </el-select>
              </div>
            </div>

            <div
              v-if="organizationData.Approved"
              class="p-5 text-sm font-semibold mt-5 text-black mb-3"
            >
              Organization Visibility
              <div class="mt-1 border-b-0.5 border-gray-300 h-full"></div>
            </div>

            <div
              v-if="organizationData.Disabled"
              class="mx-5 mb-5 p-5 text-sm bg-primary bg-opacity-20"
            >
              <p>This organization has been disabled</p>
              <p>
                By:
                <span class="font-medium">{{
                  organizationData.DisabledBy
                }}</span>
              </p>
              <p>
                Reason: <span>{{ organizationData.DisableReason }}</span>
              </p>
              <p>
                On: <span>{{ organizationData.DisabledOn | formatTime }}</span>
              </p>
              <p class="font-semibold py-2">Enable this organization?</p>
              <form @submit.prevent="enable" class="flex">
                <textarea
                  v-model="enableReason"
                  required
                  class="bg-gray-100 w-1/2 p-2"
                  placeholder="Reason"
                ></textarea>
                <button
                  type="submit"
                  class="bg-primary p-2 rounded text-xs text-white"
                >
                  Enable
                </button>
              </form>
            </div>

            <div
              v-if="organizationData.Approved && !organizationData.Disabled"
              class="px-5 text-sm"
            >
              <p class="font-semibold pb-2">Disable this organization</p>
              <form @submit.prevent="disable" class="flex gap-4">
                <textarea
                  v-model="disableReason"
                  required
                  class="bg-gray-100 w-1/2 p-2"
                  placeholder="Reason"
                ></textarea>
                <button
                  type="submit"
                  class="bg-primary p-2 rounded text-xs text-white"
                >
                  Disable
                </button>
              </form>
            </div>

            <div
              v-if="!organizationData.Approved"
              class="p-5 text-sm font-semibold mt-5 text-black"
            >
              Organization Review
              <div class="mt-1 border-b-0.5 border-gray-300 h-full"></div>
            </div>
            {{ attachmentUrl }}
            <div v-if="!organizationData.Approved" class="px-5 text-sm">
              <p class="font-semibold pb-2">Approve Organization</p>

              <transition v-if="error" name="fade">
                <div
                  class="text-xs border-1.5 border-red-400 mb-6 flex items-center p-2 gap-4 w-full"
                >
                  <img class="h-5" src="@/assets/icons/cross.png" />
                  <p class="font-bold">{{ error }}</p>
                </div>
              </transition>

              <button
                @click="approve()"
                class="bg-primary p-2 rounded text-white text-xs"
              >
                Approve
              </button>
            </div>
            <div v-if="!organizationData.Approved" class="px-5 text-sm mt-5">
              <p class="font-semibold pb-2">Decline Organization</p>
              <form @submit.prevent="disable" class="flex gap-4">
                <textarea
                  v-model="disableReason"
                  required
                  class="bg-gray-100 block w-1/2 p-2"
                  placeholder="Reason"
                ></textarea>
                <button
                  @click="Decline()"
                  class="bg-gray-500 p-2 rounded text-white text-xs"
                >
                  Decline
                </button>
              </form>
            </div>

            <attachments-viewer
              :showAttachments="showAttachments"
              :attachmentUrl="attachmentUrl"
              @close="showAttachments = false"
              @closeOnSuccess="handleCloseOnSuccess"
            ></attachments-viewer>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../loader/loader.vue";
import { mapGetters } from "vuex";
import AttachmentsViewer from "../../utils/attachmentsViewer.vue";
import moment from "moment";

export default {
  name: "ReviewOrganization",
  components: { Loader, AttachmentsViewer },
  props: ["showReviewOrganization", "organizationData"],

  data() {
    return {
      formatDate: "",
      loading: false,
      disableReason: null,
      enableReason: null,
      showAttachments: false,
      attachmentUrl: "",
      error: null,
      showPDFViewer: false,
      pdfToView: null,
      currentUserType: null,
      licenceBillingPeriods: null,
      period: null,
      edit_success: null,
      edit_error: null,
      NewPaymentTerms: null,
    };
  },
  created() {
    //console.log(this.organizationData)
    this.formatDate = moment;
    this.currentUserType = this.getUserType.toLowerCase();
    this.getLicenceBillingPeriods();
  },
  computed: {
    ...mapGetters(["getToken", "getUserType"]),
  },
  filters: {
    formatTime: function (value) {
      if (!value) return "";
      value = value.toString();
      var date = value.split("T")[0];
      var time = value.split("T")[1].substring(0, 5);
      return `${date} at ${time}`;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // checkResponse() {
    //   alert(1);
    // },
    // /organization/billing/v1/edit
    updatePaymentTerms(PaymentTermId) {
      //console.log(this.period)

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      const data = {
        OrganizationId: this.organizationData.Id,
        PaymentTermId,
      };

      axios
        .put(`organization/billing/${this.$ApiVersion}/edit`, data, options)
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              // this.edit_success = response.data.StatusMessage;
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
              // setTimeout(() => {
              //   this.edit_success = null;
              // }, 3000);
            } else {
              this.loading = false;
              // this.edit_error = response.data.StatusMessage;
              this.$notify.error({
                title: "Success",
                message: response.data.StatusMessage,
              });
              // setTimeout(() => {
              //   this.edit_error = null;
              // }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            // this.edit_error = error.message;
            this.$notify.success({ title: "Success", message: error.message });
            // setTimeout(() => {
            //   this.edit_error = null;
            // }, 3000);
          }
        );
    },

    // /organization/billing/v1/edit
    updateNewPaymentTerms() {
      this.period = this.licenceBillingPeriods.filter(
        (period) =>
          period?.Name.toLowerCase() === this.NewPaymentTerms.toLowerCase()
      );
      //console.log(this.period[0])

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      const data = {
        OrganizationId: this.organizationData.Id,
        PaymentTermId: this.period[0].Id,
      };

      axios
        .put(`organization/billing/${this.$ApiVersion}/edit`, data, options)
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.loading = false;
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
              }, 3000);
            } else {
              this.loading = false;
              this.edit_error = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.edit_error = null;
            }, 3000);
          }
        );
    },

    getLicenceBillingPeriods() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`setup/v1/request`, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.licenceBillingPeriods =
              response.data.Data.licenceBillingPeriods;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },

    async fetchPaymentTerms(queryString, callback) {
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (!queryString) {
        queryString = "annua";
      }
      //console.log(this.licenceBillingPeriods, queryString)
      this.period = this.licenceBillingPeriods.filter(
        (period) => period?.Name.toLowerCase() === queryString.toLowerCase()
      );
      //console.log(this.period[0])
      callback(this.licenceBillingPeriods);
    },

    async getBillingPeriodById(periodSelected) {
      const periodId = periodSelected;
      //console.log(periodId)
      this.licenceBillingPeriods.find(
        (location) => location.Name === periodSelected.Name
      ).Id;
      this.getDepartments(periodId);
    },
    openPDFViewer(e, url) {
      this.attachmentUrl = url;
      this.showAttachments = true;
    },
    handleCloseOnSuccess() {
      this.showAttachments = false;
    },
    disable() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      const info = {
        Disable: true,
        DisableReason: this.disableReason,
      };
      axios
        .post(
          `organization/${this.$ApiVersion}/${this.organizationData.Id}/disable`,
          JSON.stringify(info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("handleSuccess", response.data.StatusMessage);
            } else {
              this.error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.error = error.message;
          }
        );
    },
    enable() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      const info = {
        Disable: false,
        DisableReason: this.enableReason,
      };
      axios
        .post(
          `organization/${this.$ApiVersion}/${this.organizationData.Id}/disable`,
          JSON.stringify(info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("handleSuccess", response.data.StatusMessage);
            } else {
              this.error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.error = error.message;
          }
        );
    },
    formatTime(value) {
      if (value) {
        var date = value.split("T")[0];
        var time = value.split("T")[1].substring(0, 5);
        return `${date} at ${time}`;
      }
    },
    closeLeaveApplicationModal() {
      this.showLeaveApplicationModal = false;
    },

    approve() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .post(
          `/organization/${this.$ApiVersion}/${this.organizationData.Id}/approve`,
          "",
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("handleSuccess", response.data.StatusMessage);
            } else {
              this.error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.error = error.message;
          }
        );
    },
  },
};
</script>
